// Generated file : do not modify
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { TransactionTypes } from '@/generated/classes/Transaction';
import { TransactionStatuts } from '@/generated/classes/Transaction';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Liste de transaction
export class TransactionCaisse {
  // ID transaction
  public transactionId: number;
  // Code établissement
  public etablissementId: number;
  // Nom de l'établissement
  public raisonSociale: string;
  // SIRET de l'établissement
  public siret: string;
  // Nom de la caisse
  public nomCaisse: string;
  // Nom URSSAF
  public codeUrssaf: string;
  // Période
  public periode: string;
  // Montant
  public montant: number | null;
  // Détail
  public detail: TransactionCaisseDetail[];
  // N° chèque
  public deliveryId: string;
  // Date paiement
  public dateDelivery: Date | null;
  // Date encaissement
  public datePayed: Date | null;

  constructor() {
    this.transactionId = 0;
    this.etablissementId = 0;
    this.raisonSociale = '';
    this.siret = '';
    this.nomCaisse = '';
    this.codeUrssaf = '';
    this.periode = '';
    this.montant = null;
    this.detail = [];
    this.deliveryId = '';
    this.dateDelivery = null;
    this.datePayed = null;
  }
}

export class TransactionSalarie {
  // ID transaction
  public transactionId: number;
  // type
  public type: TransactionTypes;
  // Statut
  public statut: TransactionStatuts;
  // Code salarié
  public salarieId: number;
  // Nom
  public nom: string;
  // Prénom
  public prenom: string;
  // Établissement
  public etablissement: string;
  // Date
  public date: Date;
  // Montant
  public montant: number | null;
  // N° chèque
  public deliveryId: string;
  // Date encaissement
  public datePayed: Date | null;

  constructor() {
    this.transactionId = 0;
    this.type = TransactionTypes.NONE;
    this.statut = TransactionStatuts.NONE;
    this.salarieId = 0;
    this.nom = '';
    this.prenom = '';
    this.etablissement = '';
    this.date = new Date(1901,1,1,0,0,0,0);
    this.montant = null;
    this.deliveryId = '';
    this.datePayed = null;
  }
}

export class TransactionCaisseDetail {
  // Période
  public periode: Date;
  // Montant
  public montant: number;

  constructor() {
    this.periode = new Date(1901,1,1,0,0,0,0);
    this.montant = 0;
  }
}

export class TransactionCaisseQuery {
  // Code établissement
  public etablissementId: number;
  // Code caisse
  public caisseId: number;
  // Période CI98
  public periodeId: number;

  constructor() {
    this.etablissementId = 0;
    this.caisseId = 0;
    this.periodeId = 0;
  }
}

export class TransactionSalarieQuery {
  // Code salarié
  public salarieId: number;

  constructor() {
    this.salarieId = 0;
  }
}

export class TransactionEtablissement {
  // ID transaction
  public transactionId: number;
  // type
  public type: TransactionTypes;
  // Code établissement
  public etablissementId: number;
  // Nom
  public nom: string;
  // Date
  public date: Date;
  // Montant
  public montant: number | null;
  // N° virement
  public deliveryId: string;
  // Date encaissement
  public datePayed: Date | null;

  constructor() {
    this.transactionId = 0;
    this.type = TransactionTypes.NONE;
    this.etablissementId = 0;
    this.nom = '';
    this.date = new Date(1901,1,1,0,0,0,0);
    this.montant = null;
    this.deliveryId = '';
    this.datePayed = null;
  }
}

export class TransactionEtablissementQuery {
  // Code établissement
  public etablissementId: number;

  constructor() {
    this.etablissementId = 0;
  }
}

export default class TransactionList  {
  // type
  public objType: ObjTypes;
  // ids
  public ids: number[];

  constructor() {
    this.objType = ObjTypes.NONE;
    this.ids = [];
  }

  public static fromJson (obj: TransactionList): TransactionList {
    const newTransactionList: TransactionList = new TransactionList();
    newTransactionList.objType = obj.objType;
    newTransactionList.ids = JSON.parse(JSON.stringify(obj.ids));
    return newTransactionList;
  }

  public toJsonTransactionList (): string {
    const json = {
      objType: this.objType,
      ids: this.ids,
    }
    return JSON.stringify(json);
  }

  public fromTransactionList (obj: TransactionList): void {
    this.objType = obj.objType;
    this.ids = obj.ids;
  }

  public compareTransactionList (value: TransactionList): boolean {
    return (this.toJsonTransactionList() == value.toJsonTransactionList());
  }

  public cloneTransactionList (): TransactionList {
    return TransactionList.fromJson(this);
  }

  public static checkResources (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/transactionlists/checkResources', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listTransactionsCaisse (transactionQuery: TransactionCaisseQuery): Promise<TransactionCaisse[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactionlists/listTransactionsCaisse', transactionQuery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: TransactionCaisse[] = [];
              res.data.forEach(( a: TransactionCaisse ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static deliverTransactions (transactionList: TransactionList): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactionlists/deliverTransactions', transactionList, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listTransactionsSalarie (salarieQuery: TransactionSalarieQuery): Promise<TransactionSalarie[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactionlists/listTransactionsSalarie', salarieQuery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: TransactionSalarie[] = [];
              res.data.forEach(( a: TransactionSalarie ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listTransactionsEtablissement (etablissementQuery: TransactionEtablissementQuery): Promise<TransactionEtablissement[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactionlists/listTransactionsEtablissement', etablissementQuery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: TransactionEtablissement[] = [];
              res.data.forEach(( a: TransactionEtablissement ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(transactionLists: TransactionList[]) {
  }
}
